const cachedImports = new WeakSet();

const memoizeImporter = (importer) => {
  if (!importer || typeof importer !== 'function') {
    throw new Error('Importer must be a function');
  }
  return importer;
};

export const preloadRoute = (importer) => {
  const memoized = memoizeImporter(importer);
  if (!cachedImports.has(memoized)) {
    memoized();
    cachedImports.add(memoized);
  }
};

export const observePreload = (element, importer, options = {}) => {
  if (!element) {
    return () => {};
  }
  const memoized = memoizeImporter(importer);
  if (cachedImports.has(memoized)) {
    return () => {};
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          preloadRoute(memoized);
          observer.disconnect();
        }
      });
    },
    {
      rootMargin: '160px',
      threshold: 0.1,
      ...options
    }
  );
  observer.observe(element);
  return () => observer.disconnect();
};

export const attachHoverPreload = (element, importer) => {
  if (!element) {
    return () => {};
  }
  const memoized = memoizeImporter(importer);
  if (cachedImports.has(memoized)) {
    return () => {};
  }
  const handlePointerEnter = () => preloadRoute(memoized);
  element.addEventListener('pointerenter', handlePointerEnter, { passive: true });
  element.addEventListener('focus', handlePointerEnter, { passive: true });
  return () => {
    element.removeEventListener('pointerenter', handlePointerEnter);
    element.removeEventListener('focus', handlePointerEnter);
  };
};


